import { render, staticRenderFns } from "./AddGallery.vue?vue&type=template&id=d2acd444&scoped=true&"
import script from "./AddGallery.vue?vue&type=script&lang=js&"
export * from "./AddGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2acd444",
  null
  
)

export default component.exports